/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

(function() {
    const config = {
        recoverPasswordForm: document.querySelector('#RecoverPassword'),
        requestUser: document.querySelector('#RequestUser'),
        hideRecoverPasswordLink: document.querySelector('#HideRecoverPasswordLink'),
        customerLoginForm: document.querySelector('#HideRecoverPasswordLink'),
        wholesaleLoginForm: document.querySelector('.wholesale-login__form'),
        wholesaleRequestUser: document.querySelector('.wholesale-request-user'),
        resetSuccess: document.querySelector('#ResetSuccess'),
        openSidePanel: document.querySelector('.toolbar__right ul.menu li a[href="#nav-account"]'),
        closeSidePanelButton: document.querySelector('.menu__account .off-canvas__close .btn--close'),
        navAccount: document.getElementById('nav-account'),
        bodyClass: document.querySelector('body'),
        curtain: document.querySelector('#account-drawer-curtain'),
    };

    config.openSidePanel.addEventListener('click', onShowPasswordForm);
    config.closeSidePanelButton.addEventListener('click', onShowPasswordForm);
    config.curtain.addEventListener('click', toggleLoginForm);

    window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.LOG_IN,
        toggleLoginForm,
      )

    if (!config.recoverPasswordForm) {
        return;
    }

    function onShowPasswordForm(evt) {
        evt.preventDefault();
        toggleLoginForm();
    }

    checkUrlHash();
    resetPasswordSuccess();


    config.recoverPasswordForm.addEventListener('click', onShowHidePasswordForm);
    config.requestUser.addEventListener('click', onShowRequestForm);
    config.hideRecoverPasswordLink.addEventListener('click', onShowHidePasswordForm);


    function onShowHidePasswordForm(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
    }
    function onShowRequestForm(evt) {
        evt.preventDefault();
        toggleRequestUserForm();
    }

    function checkUrlHash() {
        var hash = window.location.hash;

        // Allow deep linking to recover password form
        if (hash === '#recover') {
            toggleRecoverPasswordForm();
        }

        if (hash === '#request' || hash === '#contact_form') {
            toggleRequestUserForm();
        }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
        config.recoverPasswordForm.classList.toggle('hide');
        config.customerLoginForm.classList.toggle('hide');
    }
    function toggleRequestUserForm() {
        config.wholesaleLoginForm.classList.toggle('hide');
        config.wholesaleRequestUser.classList.toggle('hide');
    }

    function toggleLoginForm() {
        if(config.navAccount.getAttribute('aria-hidden') === "true") {
            config.navAccount.setAttribute('aria-hidden', "false");
            config.bodyClass.classList.add("overflow-hidden");
            config.bodyClass.classList.add("login-sidebar--open");
            document.getElementById('CustomerEmail').focus()

        } else {
            config.navAccount.setAttribute('aria-hidden', "true");
            config.bodyClass.classList.remove("overflow-hidden");
            config.bodyClass.classList.remove("login-sidebar--open");
        }
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
        const $formState = document.querySelector('.reset-password-success');

        // check if reset password form was successfully submited.
        if (!$formState) {
            return;
        }

        // show success message
        config.resetSuccess.classList.remove('hide');
    }
})();
